const initialState = { headers: {}, query: '' };

function requestData (state = initialState) {
    return state;
}

export default requestData;
